<template>
    <div class="simple-sidebar sm-sidebar" :class="open ? 'd-block' : 'd-none d-lg-block'" id="filter_search">
        
        <div class="sidebar-widgets">
            <div class="dashboard-navbar">
                <div class="d-user-avater">
                    <!-- Profile Image with edit icon -->
                    <div class="profile-wrapper">
                        <img :src="profileImage" class="img-fluid avater" alt="profile-image">
                        <button class="edit-btn" @click="triggerFileUpload">
                            <i class="fa-solid fa-pen"></i>
                        </button>
                        <input type="file" ref="fileInput" accept="image/*" @change="uploadImage" style="display:none;">
                    </div>
                    <h4>{{ props.user?.name}}</h4>
                    <span>{{ props.user?.email}}</span>
                </div>
                <div class="d-navigation">
                    <ul>
                        <li :class="current === '/complete-profile' ? 'active' : ''"><router-link :to="`/${locale}/complete-profile`"><i class="fa-solid fa-user px-2"></i>{{t('Complete Your Profile')}}</router-link></li>
                        <li :class="current === '/register-visit' ? 'active' : ''"><router-link :to="`/${locale}/register-visit`"><i class="fa-solid fa-edit px-2"></i>{{t('Register Visit')}}</router-link></li>
                        
                        <li :class="current === '/exhibits-categories' ? 'active' : ''"><router-link :to="`/${locale}/exhibits-categories`"><i class="fa-solid fa-table-cells px-2"></i>{{t('Categories')}}</router-link></li>
                        <li :class="current === '/soon-exhibits' ? 'active' : ''"><router-link :to="`/${locale}/soon-exhibits`"><i class="fa-solid fa-box px-2"></i>{{t('Soon Exhibits')}}</router-link></li>
                        <li :class="current === '/change-password' ? 'active' : ''"><router-link :to="`/${locale}/change-password`"><i class="fa-solid fa-unlock px-2"></i>{{t('Change Password')}}</router-link></li>
                        <li>
                            <a href="#" data-bs-toggle="modal" data-bs-target="#deleteAccountModal">
                                <i class="fa-solid fa-user-xmark px-2"></i>
                                {{$t('Delete Account')}}
                            </a>
                        </li>
                        <li>
                            <a href="#" @click.prevent="logout">
                                <i class="fa-solid fa-power-off px-2"></i>{{ t('Log Out') }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="modal fade" id="deleteAccountModal" tabindex="-1" aria-labelledby="deleteAccountModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="deleteAccountModalLabel">{{$t('Confirm Delete')}}</h5>
                    <button type="button" class="btn-close ms-3" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    {{$t('Are you sure you want to delete your account?')}}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('Cancel')}}</button>
                    <button type="button" class="btn btn-danger" @click="confirmDelete">{{$t('Yes, Delete')}}</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps,computed, reactive ,defineEmits,watch} from 'vue';
import { useRoute } from 'vue-router';
import user from '@/assets/img/profile.jpg';
import { useI18n } from "vue-i18n"
import axios from 'axios'
import { useRouter } from 'vue-router';
import { useToast } from 'vue-toastification'
const { t,locale} = useI18n()
const props = defineProps({
user: {
    type: Object,
    required: true,
}
});
const emit = defineEmits(['update:user'])
const localUser = reactive({ ...props.user })
const toast = useToast()
const router = useRoute();
const current = ref(router.path);
const route = useRouter();
//logout
const logout = async () => {
    try {
        const token = localStorage.getItem('auth_token')
        await axios.post('/visitor/logout', {}, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
        localStorage.removeItem('auth_token')
        localStorage.removeItem('user_name')
        localStorage.removeItem('user_id')

        route.push(`/${locale.value}`).then(() => {
            location.reload();
        });
    } catch (error) {
        console.error('Logout failed:', error)
    }
}

const confirmDelete = async () => {
try {
    const token = localStorage.getItem('auth_token');

    if (!token) {
    toast.error(t('You are not logged in.'));
    return;
    }

    await axios.post('/delete-account', null, {
    params : {lang:locale.value},
    headers: { Authorization: `Bearer ${token}` },
    });
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user_name');
    localStorage.removeItem('user_id');

    route.push(`/${locale.value}`).then(() => location.reload());
} catch (error) {
    console.error('Delete account failed:', error);
    toast.error(error.response?.data?.message || t('Failed to delete account.'));
}
};

const profileImage = computed(() => {
    return localUser.image || user
})

// File input reference
const fileInput = ref(null)

const triggerFileUpload = () => {
    fileInput.value.click()
}

const uploadImage = async (event) => {
    const file = event.target.files[0]
    if (!file) return

    const formData = new FormData()
    formData.append('image', file)

    try {
        const token = localStorage.getItem('auth_token')

        const response = await axios.post(
            '/visitors/update-image',
            formData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )

        localUser.image = response.data.image_url  
        emit('update:user', { ...props.user, image: response.data.image_url })
        toast.success(t('Image updated successfully'))

    } catch (error) {
        console.error(error)
        toast.error(t('Failed to upload image'))
    }
}
watch(() => props.user, (newUser) => {
    Object.assign(localUser, newUser)
})
</script>
<style scoped>
.profile-wrapper {
    position: relative;
    display: inline-block;
}

.profile-wrapper img {
    border-radius: 50%;
    width: 120px;
    height: 120px;
    object-fit: cover;
}

.edit-btn {
    position: absolute;
    bottom: 5px;
    right: 5px;
    background: #fff;
    border: none;
    padding: 6px;
    border-radius: 50%;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
    cursor: pointer;
}

.edit-btn i {
    color: #333;
    font-size: 14px;
}

.edit-btn:hover {
    background: #f0f0f0;
}
</style>